import * as React from "react";
import { Box, Typography } from "@mui/material";

import Layout from "@components/Layout";

import { useIoCContext } from "@context/IoCContext/IoCContext";
import { Types } from "@ioc/types";

import NewRequestProvider from "./state/NewRequestProvider";
import { NewRequestServices } from "./model/services.model";
import { NewRequestPage } from "./ui/NewRequestPage";

import ROUTES from "@config/routes";

import BreadcrumbCustom, {
  BreadcrumbChild,
} from "@components/BreadcrumbCustom";

export default function NewRequestEntry() {
  const { serviceContainer } = useIoCContext();

  const services: NewRequestServices = React.useMemo(() => {
    return {
      clientInfoService: serviceContainer.get(
        Types.Orders.IGetClientInfoService
      ),
      productService: serviceContainer.get(
        Types.Orders.IGetPriceProductsService
      ),
      lastPaymentService: serviceContainer.get(
        Types.Orders.IGetLastPaymentService
      ),
      createOrderService: serviceContainer.get(
        Types.Orders.ICreateOrderService
      ),
    };
  }, [serviceContainer]);

  const breadcrumbDataNewOrder: BreadcrumbChild[] = [
    {
      link: ROUTES.USER_ROUTES.HOME,
      label: "Início",
    },
    {
      label: "Novo Pedido",
    },
  ];

  return (
    <Layout>
      <NewRequestProvider services={services}>
        <Box sx={{ padding: 2 }}>
          <BreadcrumbCustom data={breadcrumbDataNewOrder} />
          <Typography variant="h4" fontWeight={700} sx={{ p: 2 }}>
            Novo Pedido
          </Typography>
          <NewRequestPage />
        </Box>
      </NewRequestProvider>
    </Layout>
  );
}
